import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { WeekdayPropTypes } from 'react-day-picker';

const Abbr = styled.abbr`
  font-family: ${(props) => props.style.fontFamily};
  font-size: ${(props) => props.style.fontSize};
  font-weight: ${(props) => props.style.fontWeight};
  text-transform: ${(props) => props.style.textTransform || 'none'};
  text-decoration: ${(props) => props.style.textDecoration || 'none'};
  color: ${(props) => props.style.color};
  border: ${(props) => props.style.border || '0'};
  cursor: ${(props) => props.style.cursor || 'auto'};
`;

const Weekday = ({
  formatWeekdayTitle,
  formatWeekdayName,
  style,
  className,
  localeUtils,
  weekday,
  locale,
}) => (
  <Abbr
    style={style}
    className={className}
    title={formatWeekdayTitle({ localeUtils, weekday, locale })}
  >
    {formatWeekdayName({ localeUtils, weekday, locale })}
  </Abbr>
);

Weekday.defaultProps = {
  formatWeekdayTitle: ({ localeUtils, weekday, locale }) =>
    localeUtils.formatWeekdayLong(weekday, locale),
  formatWeekdayName: ({ localeUtils, weekday, locale }) =>
    localeUtils.formatWeekdayShort(weekday, locale)[0],
  style: {},
};

Weekday.propTypes = {
  ...WeekdayPropTypes,
  formatWeekdayTitle: PropTypes.func,
  formatWeekdayName: PropTypes.func,
  style: PropTypes.shape({
    fontFamily: PropTypes.string,
    fontSize: PropTypes.string,
    fontWeight: PropTypes.string,
    textTransform: PropTypes.string,
    textDecoration: PropTypes.string,
    color: PropTypes.string,
    border: PropTypes.string,
    cursor: PropTypes.string,
  }),
};

export default Weekday;
